import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { version } from 'config';

const Footer = () => (
  <footer className="footer">
    <Row className="justify-content-center text-center fs--1 mt-4 mb-3">
      <Col sm="auto">
        <p className="mb-0 text-600">
          © All rights reserved Eastern Motors Ltd | Powered By {' '}
          <span className="d-none d-sm-inline-block"> </span>
          <br className="d-sm-none" />
          <a href="https://techknowgram.com" target='_blank' className='text-decoration-none '><strong style={{ color: '#483285' }}>TechKnowGram Limited</strong></a>
          {/* <img className='ms-3' src={TKGL_LOGO} width="100" /> */}
        </p>
      </Col>
      {/* <Col sm="auto">
        <p className="mb-0 text-600">v{version}</p>
      </Col> */}
    </Row>
  </footer>
);

export default Footer;
